// Đọc domain từ .env - ưu tiên dùng .env nếu có, nếu không thì dùng relative path cho development
const API_ORIGIN = process.env.REACT_APP_HSV_WEB_API_URL; // Nếu không có .env, dùng /api cho development và empty string cho production
const isDevelopment = process.env.NODE_ENV === "development";

// Hàm kiểm tra xem API_ORIGIN có phải là relative path (bắt đầu bằng /) hay không
const isRelativePath = (url) => url && url.startsWith("/");

// Hàm kiểm tra xem URL đã có /api ở cuối chưa
const hasApiPath = (url) => url && url.endsWith("/api");

// Sử dụng full URL từ .env nếu có, nếu không thì dùng relative path cho development
// Nếu API_ORIGIN đã có /api ở cuối, chỉ thêm /v1
// Nếu chưa có /api, thêm /api/v1
export const API_BASE_URL = API_ORIGIN
  ? isRelativePath(API_ORIGIN)
    ? `${API_ORIGIN}/v2` // Nếu là relative path như /api, chỉ thêm /v1
    : hasApiPath(API_ORIGIN)
      ? `${API_ORIGIN}/v2` // Nếu đã có /api ở cuối, chỉ thêm /v1
      : `${API_ORIGIN}/api/v2` // Nếu chưa có /api, thêm /api/v1
  : "/api/v2"; // Relative path để vite proxy hoạt động (chỉ khi không có .env)

// AUTH_BASE_URL: Nếu API_ORIGIN đã có /api ở cuối, dùng trực tiếp
// Nếu chưa có /api, thêm /api
export const ASSET_BASE_URL = API_ORIGIN
  ? isRelativePath(API_ORIGIN)
    ? API_ORIGIN
    : hasApiPath(API_ORIGIN)
      ? API_ORIGIN.replace(/\/api$/, "")
      : API_ORIGIN
  : "";

export const AUTH_BASE_URL = API_ORIGIN
  ? isRelativePath(API_ORIGIN)
    ? API_ORIGIN // Nếu là relative path như /api, dùng trực tiếp
    : hasApiPath(API_ORIGIN)
      ? API_ORIGIN // Nếu đã có /api ở cuối, dùng trực tiếp
      : `${API_ORIGIN}/api` // Nếu chưa có /api, thêm /api
  : "/api"; // Relative path để vite proxy hoạt động (chỉ khi không có .env)

export const API_ENDPOINTS = {
  LANGUAGES: {
    UPDATE: (id) => `/languages/update/${id}`, // PUT
    CREATE: `/languages/create`, // POST
    FIND_BY_ID: (id) => `/languages/find-by-id/${id}`, // GET
    GET_ALL: `/languages/getAll`, // GET
    GET_ACTIVE: `/languages/active`, // GET
    DELETE: (id) => `/languages/delete/${id}`, // DELETE
  },

  NAVMENUS: {
    CREATE: `/nav-menus`, // POST   /api/v1/nav-menus
    UPDATE: (id) => `/nav-menus/${id}`, // PUT    /api/v1/nav-menus/{id}
    DELETE: (id) => `/nav-menus/${id}`, // DELETE /api/v1/nav-menus/{id}
    GET_BY_LANGUAGE: (languageCode) => `/nav-menus/${languageCode}`, // GET    /api/v1/nav-menus/{languageCode}
  },

  CONTACTS: {
    GET_BY_LANGUAGE: (languageCode) => `/contacts/${languageCode}`, // GET /api/v1/contacts/{languageCode}
  },

  NEWS_CATEGORIES: {
    GET_BY_LANGUAGE: (languageCode) => `/news-categories/${languageCode}`, // GET /api/v1/news-categories/{languageCode}
  },

  NEWS: {
    GET_BY_LANGUAGE: (languageCode) => `/news/${languageCode}`, // GET /api/v1/news/{languageCode}
  },

  RECRUITMENTS: {
    GET_BY_LANGUAGE: (languageCode) => `/recruitments/${languageCode}`, // GET /api/v1/recruitments/{languageCode}
  },

  RECRUITMENT_DEPARTMENTS: {
    GET_BY_LANGUAGE: (languageCode) => `/recruitment-departments/${languageCode}`,
  },

  RECRUITMENT_JOB_TYPES: {
    GET_BY_LANGUAGE: (languageCode) => `/recruitment-job-types/${languageCode}`,
  },

  CONSULTINGS: {
    GET_BY_NAV_MENU_ID: (languageCode, navMenuId) =>
      `/consultings/${languageCode}?navMenuId=${navMenuId}`, // GET /api/v1/consultings/{languageCode}?navMenuId={id}
    GET_BY_LANGUAGE: (languageCode) => `/consultings/${languageCode}`, // GET /api/v1/consultings/{languageCode}
  },

  CUSTOMERS: {
    GET_BY_LANGUAGE: (languageCode) => `/customers/${languageCode}`, // GET /api/v1/customers/{languageCode}
    GET_BY_MENU_ID: (languageCode, menuId) =>
      `/customers/${languageCode}?menuId=${menuId}`, // GET /api/v1/customers/{languageCode}?menuId={id}
  },

  TYPICAL_PROJECTS: {
    GET_BY_LANGUAGE: (languageCode) => `/typical-projects/${languageCode}`, // GET /api/v1/typical-projects/{languageCode}
  },

  SECTION_CONTENT_CARDS: {
    GET_BY_LANGUAGE: (languageCode) => `/section-content-cards/${languageCode}`,
  },

  PROJECT_INFORMATION_TYPES: {
    GET_BY_LANGUAGE: (languageCode) => `/project-information-types/${languageCode}`,
  },

  TYPICAL_PROJECT_INFORMATION_ITEMS: {
    GET_BY_LANGUAGE: (languageCode, typicalProjectId) =>
      `/typical-project-information-items/${languageCode}?typicalProjectId=${typicalProjectId}`,
  },

  LEADERS: {
    GET_BY_LANGUAGE: (languageCode) => `/leaders/${languageCode}`, // GET /api/v1/leaders/{languageCode}
  },

  LEADER_CATEGORIES: {
    GET_BY_LANGUAGE: (languageCode) => `/leader-categories/${languageCode}`, // GET /api/v1/leader-categories/{languageCode}
  },

  CUSTOMER_CATEGORIES: {
    GET_BY_LANGUAGE: (languageCode) => `/customer-categories/${languageCode}`,
  },

  ORGANIZATION_CHARTS: {
    GET_BY_LANGUAGE: (languageCode) => `/organization-charts/${languageCode}`, // GET /api/v1/organization-charts/{languageCode}
  },

  INTRODUCE_MENUS: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-menus/${languageCode}`, // GET /api/v1/introduce-menus/{languageCode}
  },

  INTRODUCE_OVERVIEWS: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-overviews/${languageCode}`, // GET /api/v1/introduce-overviews/{languageCode}
  },

  INTRODUCE_CAPACITIES: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-capacities/${languageCode}`, // GET /api/v1/introduce-capacities/{languageCode}
  },

  INTRODUCE_MESSAGES: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-messages/${languageCode}`, // GET /api/v1/introduce-messages/{languageCode}
  },

  INTRODUCE_FOUNDATIONALS: {
    GET_BY_LANGUAGE: (languageCode) =>
      `/introduce-foundationals/${languageCode}`, // GET /api/v1/introduce-foundationals/{languageCode}
  },

  INTRODUCE_VISIONS: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-visions/${languageCode}`, // GET /api/v1/introduce-visions/{languageCode}
  },

  INTRODUCE_CULTURES: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-cultures/${languageCode}`, // GET /api/v1/introduce-cultures/{languageCode}
  },

  BUSINESS_LICENSES: {
    GET_BY_LANGUAGE: (languageCode) => `/business-licenses/${languageCode}`, // GET /api/v1/business-licenses/{languageCode}
  },

  PROJECTS_IN_PROGRESS: {
    GET_BY_LANGUAGE: (languageCode) => `/projects-in-progress/${languageCode}`, // GET /api/v1/projects-in-progress/{languageCode}
  },

  PROJECTS_IN_PROGRESS_INFORMATION_ITEMS: {
    GET_BY_LANGUAGE: (languageCode, inProgressProjectId) =>
      `/projects-in-progress-information-items/${languageCode}?inProgressProjectId=${inProgressProjectId}`,
  },

  INTRODUCE_POLICIES: {
    GET_BY_LANGUAGE: (languageCode) => `/introduce-policies/${languageCode}`, // GET /api/v1/introduce-policies/{languageCode}
  },

  PRODUCT_SOLUTION_GROUPS: {
    GET_BY_LANGUAGE: (languageCode) =>
      `/product-solution-groups/${languageCode}`, // GET /api/v1/product-solution-groups/{languageCode}
  },

  PRODUCT_SOLUTION_CATEGORIES: {
    GET_BY_LANGUAGE: (languageCode) =>
      `/product-solution-categories/${languageCode}`, // GET /api/v1/product-solution-categories/{languageCode}
  },

  PRODUCT_SOLUTION_CONTENTS: {
    GET_BY_CATEGORY: (languageCode, categoryId) =>
      `/product-solution-contents/${languageCode}?productSolutionCategoryId=${categoryId}`, // GET /api/v1/product-solution-contents/{languageCode}?productSolutionCategoryId={id}
  },

  CUSTOM_PAGES: {
    GET_BY_LANGUAGE: (languageCode) => `/custom-pages/${languageCode}`,
    GET_BY_SLUG: (slug, languageCode = "vi") =>
      `/custom-pages/by-slug/${slug}?languageCode=${languageCode}`,
  },

  ADMIN: {
    AUTH: {
      LOGIN: "/auth/login",
      UPDATE_PASSWORD: "/auth/update-password",
    },
    LANGUAGES: {
      GET_ALL: "/admin/languages/getAll",
      GET_BY_ID: (id) => `/admin/languages/${id}`,
      CREATE: "/admin/languages",
      UPDATE: (id) => `/admin/languages/${id}`,
      DELETE: (id) => `/admin/languages/${id}`,
    },
    CONTACTS: {
      GET_ALL: "/admin/contacts/getAll",
      GET_BY_ID: (id) => `/admin/contacts/${id}`,
      CREATE: "/admin/contacts",
      UPDATE: (id) => `/admin/contacts/${id}`,
      DELETE: (id) => `/admin/contacts/${id}`,
    },
    USERS: {
      GET_ALL: "/admin/users/getAll",
      GET_BY_ID: (id) => `/admin/users/${id}`,
      CREATE: "/admin/users",
      UPDATE: (id) => `/admin/users/${id}`,
      DELETE: (id) => `/admin/users/${id}`,
    },
    ROLES: {
      GET_ALL: "/admin/roles/getAll",
      GET_BY_ID: (id) => `/admin/roles/${id}`,
    },
    RECRUITMENTS: {
      GET_ALL: "/admin/recruitments/getAll",
      GET_BY_ID: (id) => `/admin/recruitments/${id}`,
      CREATE: "/admin/recruitments",
      UPDATE: (id) => `/admin/recruitments/${id}`,
      DELETE: (id) => `/admin/recruitments/${id}`,
    },
    RECRUITMENT_APPLICATIONS: {
      GET_ALL: "/admin/recruitment-applications/getAll",
      GET_BY_ID: (id) => `/admin/recruitment-applications/${id}`,
      CREATE: "/recruitment-applications",
      UPDATE: (id) => `/admin/recruitment-applications/${id}`,
      DELETE: (id) => `/admin/recruitment-applications/${id}`,
    },
    RECRUITMENT_DEPARTMENTS: {
      GET_ALL: "/admin/recruitment-departments/getAll",
      GET_BY_ID: (id) => `/admin/recruitment-departments/${id}`,
      CREATE: "/admin/recruitment-departments",
      UPDATE: (id) => `/admin/recruitment-departments/${id}`,
      DELETE: (id) => `/admin/recruitment-departments/${id}`,
    },
    RECRUITMENT_JOB_TYPES: {
      GET_ALL: "/admin/recruitment-job-types/getAll",
      GET_BY_ID: (id) => `/admin/recruitment-job-types/${id}`,
      CREATE: "/admin/recruitment-job-types",
      UPDATE: (id) => `/admin/recruitment-job-types/${id}`,
      DELETE: (id) => `/admin/recruitment-job-types/${id}`,
    },
    NEWS_CATEGORIES: {
      GET_ALL: "/admin/news-categories/getAll",
      GET_BY_ID: (id) => `/admin/news-categories/${id}`,
      CREATE: "/admin/news-categories",
      UPDATE: (id) => `/admin/news-categories/${id}`,
      DELETE: (id) => `/admin/news-categories/${id}`,
    },
    NAV_MENUS: {
      // No GET ALL — use public endpoint or mock
      GET_ALL: "/admin/nav-menus/getAll",
      GET_BY_ID: (id) => `/admin/nav-menus/${id}`,
      CREATE: "/admin/nav-menus",
      UPDATE: (id) => `/admin/nav-menus/${id}`,
      DELETE: (id) => `/admin/nav-menus/${id}`,
      GET_PUBLIC: (languageCode) => `/nav-menus/${languageCode}`,
    },
    NEWS: {
      GET_ALL: "/admin/news/getAll",
      GET_BY_ID: (id) => `/admin/news/${id}`,
      CREATE: "/admin/news",
      UPDATE: (id) => `/admin/news/${id}`,
      DELETE: (id) => `/admin/news/${id}`,
    },
    SECTION_CONTENT_CARDS: {
      GET_ALL: "/admin/section-content-cards/getAll",
      GET_BY_ID: (id) => `/admin/section-content-cards/${id}`,
      CREATE: "/admin/section-content-cards",
      UPDATE: (id) => `/admin/section-content-cards/${id}`,
      DELETE: (id) => `/admin/section-content-cards/${id}`,
    },
    PROJECT_INFORMATION_TYPES: {
      GET_ALL: "/admin/project-information-types/getAll",
      GET_BY_ID: (id) => `/admin/project-information-types/${id}`,
      CREATE: "/admin/project-information-types",
      UPDATE: (id) => `/admin/project-information-types/${id}`,
      DELETE: (id) => `/admin/project-information-types/${id}`,
    },
    TYPICAL_PROJECT_INFORMATION_ITEMS: {
      GET_ALL: "/admin/typical-project-information-items/getAll",
      GET_BY_ID: (id) => `/admin/typical-project-information-items/${id}`,
      CREATE: "/admin/typical-project-information-items",
      UPDATE: (id) => `/admin/typical-project-information-items/${id}`,
      DELETE: (id) => `/admin/typical-project-information-items/${id}`,
    },
    CONSULTINGS: {
      GET_ALL: "/admin/consultings/getAll",
      GET_BY_ID: (id) => `/admin/consultings/${id}`,
      CREATE: "/admin/consultings",
      UPDATE: (id) => `/admin/consultings/${id}`,
      DELETE: (id) => `/admin/consultings/${id}`,
    },
    CUSTOMERS: {
      GET_ALL: "/admin/customers/getAll",
      GET_BY_ID: (id) => `/admin/customers/${id}`,
      CREATE: "/admin/customers",
      UPDATE: (id) => `/admin/customers/${id}`,
      DELETE: (id) => `/admin/customers/${id}`,
    },
    TYPICAL_PROJECTS: {
      GET_ALL: "/admin/typical-projects/getAll",
      GET_BY_ID: (id) => `/admin/typical-projects/${id}`,
      CREATE: "/admin/typical-projects",
      UPDATE: (id) => `/admin/typical-projects/${id}`,
      DELETE: (id) => `/admin/typical-projects/${id}`,
    },
    LEADER_CATEGORIES: {
      GET_ALL: "/admin/leader-categories/getAll",
      GET_BY_ID: (id) => `/admin/leader-categories/${id}`,
      CREATE: "/admin/leader-categories",
      UPDATE: (id) => `/admin/leader-categories/${id}`,
      DELETE: (id) => `/admin/leader-categories/${id}`,
      GET_PUBLIC: (languageCode) => `/leader-categories/${languageCode}`,
    },
    CUSTOMER_CATEGORIES: {
      GET_ALL: "/admin/customer-categories/getAll",
      GET_BY_ID: (id) => `/admin/customer-categories/${id}`,
      CREATE: "/admin/customer-categories",
      UPDATE: (id) => `/admin/customer-categories/${id}`,
      DELETE: (id) => `/admin/customer-categories/${id}`,
      GET_PUBLIC: (languageCode) => `/customer-categories/${languageCode}`,
    },
    BUSINESS_ACTIVITY_CATEGORIES: {
      GET_ALL: "/admin/business-activity-categories/getAll",
      GET_BY_ID: (id) => `/admin/business-activity-categories/${id}`,
      CREATE: "/admin/business-activity-categories",
      UPDATE: (id) => `/admin/business-activity-categories/${id}`,
      DELETE: (id) => `/admin/business-activity-categories/${id}`,
    },
    BUSINESS_ACTIVITIES: {
      GET_ALL: "/admin/business-activities/getAll",
      GET_BY_ID: (id) => `/admin/business-activities/${id}`,
      CREATE: "/admin/business-activities",
      UPDATE: (id) => `/admin/business-activities/${id}`,
      DELETE: (id) => `/admin/business-activities/${id}`,
    },
    LEADERS: {
      GET_ALL: "/admin/leaders/getAll",
      GET_BY_ID: (id) => `/admin/leaders/${id}`,
      CREATE: "/admin/leaders",
      UPDATE: (id) => `/admin/leaders/${id}`,
      DELETE: (id) => `/admin/leaders/${id}`,
    },
    LEADER_INFORMATION_ITEMS: {
      GET_ALL: "/admin/leader-information-items/getAll",
      GET_BY_ID: (id) => `/admin/leader-information-items/${id}`,
      CREATE: "/admin/leader-information-items",
      CREATE_BATCH: "/admin/leader-information-items/addBatch",
      UPDATE: (id) => `/admin/leader-information-items/${id}`,
      DELETE: (id) => `/admin/leader-information-items/${id}`,
    },
    ORGANIZATION_CHARTS: {
      GET_ALL: "/admin/organization-charts/getAll",
      GET_BY_ID: (id) => `/admin/organization-charts/${id}`,
      CREATE: "/admin/organization-charts",
      UPDATE: (id) => `/admin/organization-charts/${id}`,
      DELETE: (id) => `/admin/organization-charts/${id}`,
    },
    INTRODUCE_MENUS: {
      GET_ALL: "/admin/introduce-menus/getAll",
      GET_BY_ID: (id) => `/admin/introduce-menus/${id}`,
      CREATE: "/admin/introduce-menus",
      UPDATE: (id) => `/admin/introduce-menus/${id}`,
      DELETE: (id) => `/admin/introduce-menus/${id}`,
    },
    INTRODUCE_OVERVIEWS: {
      GET_ALL: "/admin/introduce-overviews/getAll",
      GET_BY_ID: (id) => `/admin/introduce-overviews/${id}`,
      CREATE: "/admin/introduce-overviews",
      UPDATE: (id) => `/admin/introduce-overviews/${id}`,
      DELETE: (id) => `/admin/introduce-overviews/${id}`,
    },
    INTRODUCE_CAPACITIES: {
      GET_ALL: "/admin/introduce-capacities/getAll",
      GET_BY_ID: (id) => `/admin/introduce-capacities/${id}`,
      CREATE: "/admin/introduce-capacities",
      UPDATE: (id) => `/admin/introduce-capacities/${id}`,
      DELETE: (id) => `/admin/introduce-capacities/${id}`,
    },
    INTRODUCE_MESSAGES: {
      GET_ALL: "/admin/introduce-messages/getAll",
      GET_BY_ID: (id) => `/admin/introduce-messages/${id}`,
      CREATE: "/admin/introduce-messages",
      UPDATE: (id) => `/admin/introduce-messages/${id}`,
      DELETE: (id) => `/admin/introduce-messages/${id}`,
    },
    INTRODUCE_FOUNDATIONALS: {
      GET_ALL: "/admin/introduce-foundationals/getAll",
      GET_BY_ID: (id) => `/admin/introduce-foundationals/${id}`,
      CREATE: "/admin/introduce-foundationals",
      UPDATE: (id) => `/admin/introduce-foundationals/${id}`,
      DELETE: (id) => `/admin/introduce-foundationals/${id}`,
    },
    BUSINESS_LICENSES: {
      GET_ALL: "/admin/business-licenses/getAll",
      GET_BY_ID: (id) => `/admin/business-licenses/${id}`,
      CREATE: "/admin/business-licenses",
      UPDATE: (id) => `/admin/business-licenses/${id}`,
      DELETE: (id) => `/admin/business-licenses/${id}`,
    },
    PRODUCT_SOLUTION_GROUPS: {
      GET_ALL: "/admin/product-solution-groups/getAll",
      GET_BY_ID: (id) => `/admin/product-solution-groups/${id}`,
      CREATE: "/admin/product-solution-groups",
      UPDATE: (id) => `/admin/product-solution-groups/${id}`,
      DELETE: (id) => `/admin/product-solution-groups/${id}`,
    },
    ECOSYSTEM_GROUPS: {
      GET_ALL: "/admin/ecosystem-groups/getAll",
      GET_BY_ID: (id) => `/admin/ecosystem-groups/${id}`,
      CREATE: "/admin/ecosystem-groups",
      UPDATE: (id) => `/admin/ecosystem-groups/${id}`,
      DELETE: (id) => `/admin/ecosystem-groups/${id}`,
    },
    ECOSYSTEM_SERVICES: {
      GET_ALL: "/admin/ecosystem-services/getAll",
      GET_BY_ID: (id) => `/admin/ecosystem-services/${id}`,
      CREATE: "/admin/ecosystem-services",
      UPDATE: (id) => `/admin/ecosystem-services/${id}`,
      DELETE: (id) => `/admin/ecosystem-services/${id}`,
    },
    PRODUCT_SOLUTION_CATEGORIES: {
      GET_ALL: "/admin/product-solution-categories/getAll",
      GET_BY_ID: (id) => `/admin/product-solution-categories/${id}`,
      CREATE: "/admin/product-solution-categories",
      UPDATE: (id) => `/admin/product-solution-categories/${id}`,
      DELETE: (id) => `/admin/product-solution-categories/${id}`,
    },
    PRODUCT_SOLUTION_CONTENTS: {
      GET_ALL: "/admin/product-solution-contents/getAll",
      GET_BY_ID: (id) => `/admin/product-solution-contents/${id}`,
      CREATE: "/admin/product-solution-contents",
      UPDATE: (id) => `/admin/product-solution-contents/${id}`,
      DELETE: (id) => `/admin/product-solution-contents/${id}`,
    },
    PROJECTS_IN_PROGRESS: {
      GET_ALL: "/admin/projects-in-progress/getAll",
      GET_BY_ID: (id) => `/admin/projects-in-progress/${id}`,
      CREATE: "/admin/projects-in-progress",
      UPDATE: (id) => `/admin/projects-in-progress/${id}`,
      DELETE: (id) => `/admin/projects-in-progress/${id}`,
    },
    PROJECTS_IN_PROGRESS_INFORMATION_ITEMS: {
      GET_ALL: "/admin/projects-in-progress-information-items/getAll",
      GET_BY_ID: (id) => `/admin/projects-in-progress-information-items/${id}`,
      CREATE: "/admin/projects-in-progress-information-items",
      CREATE_BATCH: "/admin/projects-in-progress-information-items/addBatch",
      UPDATE: (id) => `/admin/projects-in-progress-information-items/${id}`,
      DELETE: (id) => `/admin/projects-in-progress-information-items/${id}`,
    },
    INTRODUCE_VISIONS: {
      GET_ALL: "/admin/introduce-visions/getAll",
      GET_BY_ID: (id) => `/admin/introduce-visions/${id}`,
      CREATE: "/admin/introduce-visions",
      UPDATE: (id) => `/admin/introduce-visions/${id}`,
      DELETE: (id) => `/admin/introduce-visions/${id}`,
    },
    INTRODUCE_ORIENTATIONS: {
      GET_ALL: "/admin/introduce-orientations/getAll", // in router it's GET /api/v1/admin/introduce-orientations
      GET_BY_ID: (id) => `/admin/introduce-orientations/${id}`,
      CREATE: "/admin/introduce-orientations",
      UPDATE: (id) => `/admin/introduce-orientations/${id}`,
      DELETE: (id) => `/admin/introduce-orientations/${id}`,
    },
    INTRODUCE_CULTURES: {
      GET_ALL: "/admin/introduce-cultures/getAll",
      GET_BY_ID: (id) => `/admin/introduce-cultures/${id}`,
      CREATE: "/admin/introduce-cultures",
      UPDATE: (id) => `/admin/introduce-cultures/${id}`,
      DELETE: (id) => `/admin/introduce-cultures/${id}`,
    },
    INTRODUCE_POLICIES: {
      GET_ALL: "/admin/introduce-policies/getAll",
      GET_BY_ID: (id) => `/admin/introduce-policies/${id}`,
      CREATE: "/admin/introduce-policies",
      UPDATE: (id) => `/admin/introduce-policies/${id}`,
      DELETE: (id) => `/admin/introduce-policies/${id}`,
    },
    HOME_BANNERS: {
      GET_ALL: "/admin/home-banners/getAll",
      GET_BY_ID: (id) => `/admin/home-banners/${id}`,
      CREATE: "/admin/home-banners",
      UPDATE: (id) => `/admin/home-banners/${id}`,
      DELETE: (id) => `/admin/home-banners/${id}`,
    },
    CUSTOM_PAGES: {
      GET_ALL: "/admin/custom-pages/getAll",
      GET_BY_ID: (id) => `/admin/custom-pages/${id}`,
      CREATE: "/admin/custom-pages",
      UPDATE: (id) => `/admin/custom-pages/${id}`,
      DELETE: (id) => `/admin/custom-pages/${id}`,
    },
  },
};
